/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magic-wand': {
    width: 24,
    height: 24,
    viewBox: '-8 -8 40 40',
    data: '<g><g _stroke="#000"><line pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="2.5" y1="21.5" x2="16.104" y2="7.979"/><polygon pid="1" _fill="none" stroke-linejoin="round" stroke-miterlimit="10" points="20.795,3.274 19.734,6.457 21.855,8.578 18.674,8.225 16.906,11.407 16.111,7.958 12.664,7.164 15.846,5.396 15.492,2.214 17.613,4.335"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/magic-wand.js